import { apiRequest } from "../midldleware/axiosInstance";

// customer
export const listCustomer = (playload) =>
  apiRequest("POST", "list-customer", playload);

export const searchStore = (playload) =>
  apiRequest("POST", "search-store", playload);

export const storesCount = (playload) =>
  apiRequest("POST", "store-count", playload);


export const viewCustomer = (playload) =>
  apiRequest("POST", "view-member", playload);

export const getModules = () => 
  apiRequest("GET", "get-modules");

export const getStoreModules = (storeid)=>
  apiRequest('GET', `list-store-modules?mainstoreid=${storeid}`);
  
export const enableModuleAPI = (playload) =>
  apiRequest("POST", 'enable-module',playload);

export const disableModuleAPI = (playload) =>
  apiRequest("PATCH" ,"disable-module",playload);
  
//store
export const listMainStores = (playload) =>
  apiRequest("POST", "list-main-store", playload);

//login
export const AuthTokenData = () =>
  apiRequest("GET", "auth-token", {});

//setting
export const listSetting = (id) =>
  apiRequest("GET", `module/settings?mainstoreid=${id}`);

export const brandingSetting = (playload) =>
  apiRequest("POST", "module/settings", playload);

export const getInvoiceAnalytics = (playload) =>
  apiRequest("POST", "module/analytics/invoice", playload);

export const storeSummary = (playload) =>
  apiRequest("POST", "module/analytics/", playload);
